import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SalesUnit } from '../../types/sales-unit';

import { BarcodeComponent } from '@softline/ui-core/code';
@Component({
    selector: 'soft-sales-unit-card',
    imports: [CommonModule,
    BarcodeComponent],
    templateUrl: './sales-unit-card.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './sales-unit-card.component.css'
})
export class SalesUnitCardComponent {
  salesUnit = input.required<SalesUnit>();
}
